/**
 * SOLOMON — LEADS VIEW
 * Outer container that switches between the pipeline list and a single
 * lead's detail view. One ToolModal entry, two surfaces.
 *
 * Accepts optional `initialLeadId` for deep-link entry (CallQueuePanel
 * dispatches `solomon:open-lead` → App.jsx sets pendingLeadId → here).
 * The id is consumed once on first mount so re-opening the Leads modal
 * from the Tools menu lands on the list, not on the previous deep-link.
 */

import { useState, useCallback, useEffect } from 'react';
import LeadsList from './LeadsList';
import LeadDetail from './LeadDetail';

export default function LeadsView({ initialLeadId = null, onConsumeInitialLeadId }) {
  const [selectedLeadId, setSelectedLeadId] = useState(initialLeadId);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    if (initialLeadId) {
      setSelectedLeadId(initialLeadId);
      onConsumeInitialLeadId?.();
    }
  }, [initialLeadId, onConsumeInitialLeadId]);

  const onSelect = useCallback((leadId) => setSelectedLeadId(leadId), []);
  const onBack   = useCallback(() => {
    setSelectedLeadId(null);
    setRefreshKey((k) => k + 1);
  }, []);

  if (selectedLeadId) {
    return (
      <LeadDetail
        leadId={selectedLeadId}
        onBack={onBack}
        onNavigate={onSelect}
      />
    );
  }
  return <LeadsList onSelect={onSelect} refreshKey={refreshKey} />;
}
